var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "url(#pattern0_641_449)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_449",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_449",
    transform: "matrix(0.0340909 0 0 0.03125 -0.0454545 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_449",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAmBJREFUWIW9ls9rE0EUx79vZ4PUNhQhdJOycQ3RNoF68CLopdEePHjx7D8gNCDYowcpiEfFg9YKnntVEA+CP+rFgz0ICmpjCWyStpuDiL8Kkt15XpK2STfJ7iTuXHbnvTfv+2H27cwTGMKYyMwY8fiRtbHxhPH757fXYdZqwwAQbuMOgDwYx8KuHRgglc5dYOAyADBhNVIA0zRHGHx/10AcLYCrjS4CyDan1XqlVI4MwDBzJ8G4tmfhVyp5VAE00vghgNg+02pkAIaZK4Jxps0owhcgAFDYBQkrn9Kl/AxgfJ+54lTXLRWA0DsgpFzqEAeAlyrioQGS1omLBFw64FD4/VpDDxqYSEzHIbHs5yMh3vx3AP0w3wKT6ePy4PKjVDrnu47BO0J6xc3NjZqfP1ARJs2p0yB6C0AEBW6D0DBXt9d9z4kANVDQAW1ZVRzA827iQIBPkDS3F0A4pSi+w8TzvQJ67kAqk7dAuKEoDjAW+90PPQG44d0DMKoo/9Exxu72C+pahMbRqTlieqEo7oH5rFMrvesX2LUGhOuVpNCfEmikWwyDz8GvOImXnGp/cUDhLmiNyclsWgq94uPa/htr5L+Xyz+C5FHuB6QeO++fkOeDig8EAJaFAybQ461q6UmYNAO0ZNQOQPilS/dq2CxqDYk1nQE6WnBJ17ud90MHIIlCh2nNqX15oJJL8RO0bb+rad4VAF50AMyze++4vWVvvFfKgxD9QGtMpI9nAVhNcZsbh26qigMKO0AsCrsTIYv1+oc/0QIAs83nimN/fTaIuBIAE2yAPnl6bGFQcQD4B4XrtLyoIglSAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickinfo);
export default __webpack_public_path__ + "static/media/quickinfo.252fbcf63c47e32b4959d4f5994c20ad.svg";
export { ForwardRef as ReactComponent };